<template>
    <simple-button
        v-if="condition"
        @click="$emit('click')"
        :icon="icon"
        :size="size"
        icon-position="left"
        white-background
    >
        <slot name="title">{{ title }}</slot>
    </simple-button>
</template>

<script>
import SvgIcon from "./SvgIcon.vue";
import SimpleButton from "./SimpleButton.vue";

export default {
    name: "ApplicationButton",
    components: {SimpleButton, SvgIcon},
    props: {
        condition: {
            type: Boolean,
            default: true
        },
        title: {
            type: String,
            default: ''
        },
        icon: {
            type: String,
        },
        size: {
            type: String,
            default: 'small',
            validator(value) {
                return ['medium', 'small'].includes(value);
            }
        },
        buttonClass: {
            type: String,
            default: ''
        },
        iconClass: {
            type: String,
            default: ''
        }
    },
}

</script>

<style scoped>

</style>
